import { render, staticRenderFns } from "./yesAreaSelect.vue?vue&type=template&id=12c56036"
import script from "./yesAreaSelect.vue?vue&type=script&lang=js"
export * from "./yesAreaSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports